import React from 'react';
import { motion } from 'framer-motion';
import { MailIcon, LinkedinIcon } from 'lucide-react';
export function Contact() {
  return <section id="contact" className="py-24 md:py-36 bg-dark text-white relative overflow-hidden" data-id="element-44">
      {/* Decorative terracotta glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full bg-accent opacity-[0.12] blur-3xl pointer-events-none" aria-hidden="true" data-id="element-45" />
      {/* Secondary teal glow */}
      <div className="absolute -bottom-20 -left-20 w-[400px] h-[400px] rounded-full bg-accent-secondary opacity-[0.08] blur-3xl pointer-events-none" aria-hidden="true" data-id="element-46" />

      <div className="max-w-4xl mx-auto px-6 text-center relative z-10" data-id="element-47">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-48">
          <h2 className="text-4xl md:text-6xl font-serif mb-6 leading-tight" data-id="element-49">
            Let's Build Something <span className="text-accent" data-id="element-50">Together.</span>
          </h2>
          <p className="text-lg text-gray-400 mb-12 max-w-2xl mx-auto leading-relaxed" data-id="element-51">
            Currently open for new opportunities. Whether you have a complex
            regulatory product to build or a mobile experience to refine, I'd
            love to chat.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-52">
            <a href="mailto:hello@example.com" className="inline-flex items-center justify-center space-x-2 bg-accent text-white px-8 py-4 font-bold hover:bg-white hover:text-dark transition-colors duration-300 w-full sm:w-auto" data-id="element-53">
              <MailIcon className="w-5 h-5" data-id="element-54" />
              <span data-id="element-55">Send an Email</span>
            </a>
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center space-x-2 border-2 border-white/30 text-white px-8 py-4 font-bold hover:bg-accent-secondary hover:border-accent-secondary transition-colors duration-300 w-full sm:w-auto" data-id="element-56">
              <LinkedinIcon className="w-5 h-5" data-id="element-57" />
              <span data-id="element-58">Connect on LinkedIn</span>
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}